import { Outlet, useLoaderData } from 'react-router'

import type { loader as contentLoader } from '../loader'
import { ConsumerSideNavigationMobile } from '~/portal/components/ConsumerSideNavigationMobile'

export const MobileView = ({ tableOfContents, branding }) => {
  const { accentColor } = branding
  const { currentProduct, products } = useLoaderData<typeof contentLoader>()

  return (<>
    <section className="sp-content h-full overflow-hidden xl:hidden"><Outlet /></section>
    <ConsumerSideNavigationMobile
      products={products}
      currentProduct={currentProduct}
      tableOfContents={tableOfContents}
      accentColor={accentColor}
    />
  </>)
}